import React from 'react';
import { Link } from 'react-router-dom';
import Pricing from '../../../../CommonComponents/ProductCard/Pricing';
import { removeDomainName } from '../../../../utils/helper';
import './SimilarProduct.scss';

export default function SimilarProduct({ item, dataLocale, localeInfo, currencyMark }) {
  const blueStyle = {
    fontSize: '14px',
  };
  const greyStyle = {
    fontSize: '14px',
  };
  const secondaryStyle = {
    fontSize: '12px',
  };
  const lenskartPrice = item && item?.prices[1].price;
  const firstBuyPrice = item && item?.prices.length === 3 && item?.prices[2]?.price;
  const finalprice = item?.prices.length === 3 ? firstBuyPrice : lenskartPrice;
  const marketPrice = item?.prices[0].price;
  const currencyCode =
    item && item?.prices && item?.prices?.length > 0
      ? item?.prices[0]?.currencyCode
      : dataLocale && dataLocale?.CURRENCY_CODE;
  const currencySymbol =
    currencyMark && currencyCode ? <span>{currencyMark[currencyCode]}</span> : null;

  const productUrl = {
    pathname:
      item?.productUrl &&
      removeDomainName(
        removeDomainName(item.productUrl, localeInfo?.domain),
        localeInfo?.domainUrl,
        localeInfo?.countryCode
      ),
    state: { productId: item.id, section: 'prod' },
  };

  return (
    <Link target="_blank" to={productUrl}>
      <div className="similar-product-container">
        <div className="product-image-container">
          <img alt={item?.brandName} src={item?.imageUrl} />
        </div>
        <div className="title-container">
          <div className="title">{item?.brandName}</div>
        </div>
        <Pricing
          blueStyle={blueStyle}
          currencySymbol={currencySymbol}
          dataLocale={dataLocale}
          finalprice={finalprice}
          greyStyle={greyStyle}
          localeInfo={localeInfo}
          marketPrice={marketPrice}
          secondaryStyle={secondaryStyle}
        />
      </div>
    </Link>
  );
}
